import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button } from 'semantic-ui-react';
import { FormattedData } from 'Components';

import { getImportResult } from './../state/resultgrid/actions';
import { Filter, Main } from '../../../containers';

class ResultDetailsContainer extends Component {
  static path = '/importresult/:recordId';

  state = {
    showAdvanced: false,
  };

  getRootUrl = () => {
    const { url } = this.props.match;
    return url.substring(0, url.lastIndexOf('/'));
  };

  getMainProps = () => {
    return {
      usePageWidth: true,
      toolbox: {
        backButtonProps: {
          shown: true,
          path: this.getRootUrl(),
        },
        shown: true,
      },
    };
  };

  componentDidMount() {
    const {
      match: {
        params: { recordId },
      },
    } = this.props;

    if (!this.getRecord()) {
      this.props.getImportResult(recordId);
    }
  }

  getRecord() {
    const {
      match: {
        params: { recordId },
      },
      importResults,
    } = this.props;
    return importResults.find((ele) => ele.Id === parseInt(recordId, 10));
  }

  render() {
    var record = this.getRecord();
    if (!record) {
      return null;
    }
    return (
      <Fragment>
        <Filter title={'Import Results'} />
        <Main {...this.getMainProps()}>
          <FormattedData
            title={this.state.showAdvanced ? 'Import Data' : 'Import Result'}
            data={this.state.showAdvanced ? record : JSON.parse(record.Result)}
          />

          <Button
            secondary
            onClick={() =>
              this.setState({ showAdvanced: !this.state.showAdvanced })
            }
          >
            {this.state.showAdvanced ? 'Hide Advanced' : 'Show Advanced'}
          </Button>
          {record.ProcessedDocumentId && (
            <Button
              secondary
              onClick={() => {
                this.props.history.push(
                  `/ProcessedDocuments?view=${record.ProcessedDocumentId}`
                );
              }}
            >
              View Import Result Report
            </Button>
          )}
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    importResults: state.ImportResultState.resultGrid.importResults,
  };
};

const ResultDetails = withRouter(
  connect(mapStateToProps, { getImportResult })(ResultDetailsContainer)
);
export { ResultDetails };



// WEBPACK FOOTER //
// ./src/pages/importresult/subpages/ResultDetails.js